import { render, staticRenderFns } from "./buy-policy-tips.vue?vue&type=template&id=5af51118&scoped=true&"
import script from "./buy-policy-tips.vue?vue&type=script&lang=js&"
export * from "./buy-policy-tips.vue?vue&type=script&lang=js&"
import style0 from "./buy-policy-tips.vue?vue&type=style&index=0&id=5af51118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af51118",
  null
  
)

export default component.exports